import gql from 'graphql-tag';

export const LISTING_MAP_VIEW_QUERY = gql`
    fragment listingFragment on Listing {
        numberOfVideos
        numberOfImages
        numberOfFloorPlans
        numberOfViews
        listingId
        title
        publishedOnLabel
        publishedOn
        availableFrom
        priceDrop {
            lastPriceChangeDate
            percentageChangeLabel
        }
        isPremium
        highlights {
            description
            label
            url
        }
        otherPropertyImages {
            small
            large
            caption
        }
        branch {
            name
            branchDetailsUri
            phone
            logoUrl
        }
        features {
            content
            iconId
        }
        image {
            src
            caption
            responsiveImgList {
                width
                src
            }
        }
        transports {
            title
            poiType
            distanceInMiles
            features {
                zone
                tubeLines
            }
        }
        flag
        listingId
        priceTitle
        shortPriceTitle
        price
        address
        tags {
            content
        }
        listingUris {
            contact
            detail
        }
        location {
            coordinates {
                latitude
                longitude
            }
        }
    }

    query getListingMapView($path: String!) {
        searchResults(path: $path) {
            analyticsTaxonomy {
                activity
                areaName
                bedsMax
                bedsMin
                brand
                countryCode
                countyAreaName
                currencyCode
                emailAllFormShown
                emailAllTotalAgents
                expandedResultsCount
                listingsCategory
                location
                outcode
                outcodes
                page
                postalArea
                priceMax
                priceMin
                propertyType
                radius
                radiusAutoexpansion
                regionName
                resultsSort
                searchGuid
                searchIdentifier
                searchLocation
                searchResultsCount
                section
                totalResults
                url
                viewType
                geoIdentifier
            }
            analyticsEcommerce {
                currencyCode
                impressions {
                    id
                    list
                    position
                    variant
                }
            }
            metaInfo {
                title
                description
                canonicalUri
            }
            pagination {
                pageNumber
                totalResults
                totalResultsWasLimited
            }
            listings {
                regular {
                    ...listingFragment
                }
                featured {
                    ...listingFragment
                }
                extended {
                    ...listingFragment
                }
            }
            filters {
                fields {
                    group
                    fieldName
                    label
                    isRequired
                    inputType
                    placeholder
                    allowMultiple
                    options
                    value
                }
            }
            sortOrder {
                currentSortOrder
                options {
                    i18NLabelKey
                    value
                }
            }
            seoBlurb {
                category
                transactionType
            }
            links {
                saveSearch
                createAlert
            }
            polygonV2(path: $path) {
                polygons
                radius
                geoData {
                    coordinates
                }
                geoType
            }
            polyenc
        }
    }
`;
